import fly from '@/utils/request'

export const baseURL = fly.config.baseURL

// 登陆登出
export function userLogin (data) {
  return fly.post('apiUser_login.html', data)
}

export function logout () {
  return fly.post('apiUser_loginout.html')
}

// 图片上传 img 图片数据流base64，type 类别(1文章/视频/音频素材,2功能素材,3验配网点)
export function uploadImage (data) {
  return fly.post('api_uploadImage.html', data)
}

// 德维尔
export function getFunctionList (data) {
  return fly.post('apiMaterial_getFunctionList.html', data)
}

//log 相关接口
export function exportBkUserToExcel (data) {
  return fly.config.baseURL + '/apiAccount_exportBkUserAccessList.html?' + params(data)
}

export function getBkUserAccessList (data) {
  return fly.post('apiAccount_getBkUserAccessList.html', data)
}

// 销售管理
export function getClientList (data) {
  return fly.post('apiSale_getClientList.html', data)
}

export function getInvoiceApplyList (data) {
  return fly.post('apiSale_getInvoiceApplyList.html', data)
}

export function getBillList (data) {
  return fly.post('apiSale_getBillList.html', data)
}

export function getInvoiceList (data) {
  return fly.post('apiSale_getInvoiceList.html', data)
}

export function getInvoiceDetail (data) {
  return fly.post('apiSale_getInvoiceDetail.html', data)
}

export function exportInvoiceApplyToExcel (data) {
  return fly.config.baseURL + '/apiSale_exportInvoiceApplyList.html?' + params(data)
}

export function exportBillListToExcel (data) {
  return fly.config.baseURL + '/apiSale_exportBillList.html?' + params(data)
}

export function exportInvoiceToExcel (data) {
  return fly.config.baseURL + '/apiSale_exportInvoiceList.html?' + params(data)
}

export function exportPayToExcel (data) {
  return fly.config.baseURL + '/apiPurchase_exportPayPlanList.html?' + params(data)
}

export function _exportPayToExcel (data) {
  return fly.config.baseURL + '/apiPurchase_exportPayList.html?' + params(data)
}

// 供应商管理
export function getVendorList (data) {
  return fly.post('apiPurchase_getVendorList.html', data)
}

export function getContractList (data) {
  return fly.post('apiPurchase_getContractList.html', data)
}

export function getPayPlanList (data) {
  return fly.post('apiPurchase_getPayPlanList.html', data)
}

// 项目管理
export function getProjectList (data) {
  return fly.post('apiProject_getList.html', data)
}

export function getProjectDetail (data) {
  return fly.post('apiProject_getDetail.html', data)
}

export function getPayDetail (data) {
  return fly.post('apiProject_getPayDetail.html', data)
}

export function exportProjectToExcel (data) {
  return fly.config.baseURL + '/apiProject_exportList.html?' + params(data)
}

export function params (obj) {
  var str = []
  for (var key in obj)
  if (Object.prototype.hasOwnProperty.call(obj, key) && obj[key] !== undefined) {
    // str.push(encodeURIComponent(key) + '=' + encodeURIComponent(obj[key]))
    str.push(key + '=' + obj[key])
  }
  return str.join('&')
}


// 标签
export function getTagList (data) {
  return fly.post('apiTag_getTagList.html', data)
}

export function delTag (data) {
  return fly.post('apiTag_delTag.html', data)
}

export function addTag (data) {
  return fly.post('apiTag_addUpdateTag.html', data)
}

export function getUserByTag (data) {
  return fly.post('apiTag_getUserByTag.html', data)
}

// 积分
export function apiUser_getSourceList (data) {
  return fly.post('/apiUser_getSourceList.html', data)
}

export function apiUser_addUpdateSource (data) {
  return fly.post('/apiUser_addUpdateSource.html', data)
}

export function apiUser_delSource (data) {
  return fly.post('/apiUser_delSource.html', data)
}

//账号
export function getAccountDetail (data) {
  return fly.post('apiAccount_getUserDetail.html', data)
}

export function getMenuList (data) {
  return fly.post('apiAccount_getMenuList.html', data)
}

export function addUpdateUser (data) {
  return fly.post('apiAccount_addUpdateUser.html', data)
}

export function updateUserPwd (data) {
  return fly.post('apiAccount_updateUserPwd.html', data)
}

//文件上传下载

export function uploadFile(data) {
  return fly.post('api_uploadFile.html', data , {
    headers: {'Content-Type': 'application/form-data'}
  })
}
 
export function downLoad(data) {
  return fly.get('api_uploadFile.html', data, {
    headers: {'Content-Type': 'application/form-data'}
  })
}

// 行政项目管理
export function getAdminProjectList (data) {
  return fly.post('ApiAdministrative_projectList.html', data)
}

export function getAdminProjectDetail (data) {
  return fly.post('ApiAdministrative_projectDetail.html', data)
}

export function getAdminPayPlanList (data) {
  return fly.post('ApiAdministrative_getPayPlanList.html', data)
}

export function getAdminContractList (data) {
  return fly.post('ApiAdministrative_getContractList.html', data)
}

// 报销管理
export function oldGetExpenseList (data) {
  return fly.post('ApiStaffReimbursement_getStaffReimbursementList.html', data)
}

// 报销管理
export function getExpenseList (data) {
  return fly.post('ApiStaffReimbursement_getReimList.html', data)
}

// 报销管理
export function getPersonExpenseList (data) {
  return fly.post('ApiStaffReimbursement_getStaffReimbursementList.html', data)
}

//导出报销列表
export function exportExpenseToExcel (data) {
  return fly.config.baseURL + '/ApiStaffReimbursement_exportReimbursementList.html?' + params(data)
}

//下载报销附件
export function exportExpenseAttachmentToExcel (data) {
  return fly.config.baseURL + '/ApiStaffReimbursement_downloadAttachment.html?' + params(data)
}

//下载附件
export function exportExpenseStaffToExcel (data) {
  return fly.config.baseURL + '/ApiStaffReimbursement_export.html?' + params(data)
}

//注释颜色
export function markProjectList (data) {
  return fly.post('apiProject_addOrUpdateMark.html', data)
}

//项目列表统计
export function getListCount (data) {
  return fly.post('apiProject_getListCount.html', data)
}

//行政人力资源项目列表统计
export function getAdListCount (data) {
  return fly.post('ApiAdministrative_projectListCount.html', data)
}

//支付列表统计
export function getPlanStatic (data) {
  return fly.post('apiPurchase_payPlanStatistics.html', data)
}

//获取权限页面菜单列表
export function getMenuNodeList (data) {
  return fly.post('ApiNode_getMenuNodeList.html', data)
}

//获取权限页面权限列表
export function getNodeList (data) {
  return fly.post('ApiNode_getNodeList.html', data)
}

//获取获取子级权限操作权限
export function getChildNodeList (data) {
  return fly.post('ApiNode_getChildNode.html', data)
}

//判断页面权限
export function checkLoginUrl (data) {
  return fly.post('Api_checkLoginUrl.html', data)
}

//获取页面的操作权限
export function checkNode (data) {
  return fly.post('Api_checkNode.html', data)
}

// 休假管理
export function getHolidayList (data) {
  return fly.post('ApiHoliday_getHolidayList.html', data)
}

//导出报销列表
export function exportVacationToExcel (data) {
  return fly.config.baseURL + '/ApiHoliday_getHolidayList.html?' + params(data)
}

// 员工休假明细列表
export function getHolidayDetail (data) {
  return fly.post('ApiHoliday_getHolidayDetail.html', data)
}

// 假期说明
export function getHolidayInfo (data) {
  return fly.post('ApiHoliday_getHolidayInfo.html', data)
}

// 假期类型
export function getHolidayType (data) {
  return fly.post('ApiHoliday_getHolidayType.html', data)
}

// 代理人下拉
export function getAgentList (data) {
  return fly.post('ApiHoliday_getAgentList.html', data)
}

// 获取休假详情
export function getStaffHolidayDetail (data) {
  return fly.post('ApiHoliday_getStaffHolidayDetail.html', data)
}

// 获取休假详情
export function holidayReview (data) {
  return fly.post('ApiHoliday_holidayReview.html', data)
}

// 获取办公用品列表
export function AssetList (data) {
  return fly.post('ApiAsset_getAssetList.html', data)
}

export function getOfficeList (data) {
  return fly.post('apiOffice_getOfficeList.html', data)
}

export function getAssetInfo (data) {
  return fly.post('apiAsset_getAssetInfo.html', data)
}

export function getSecondaryNames (data) {
  return fly.post('ApiAsset_getSecondaryNames.html', data)
}

export function exportAssetList (data) {
  return fly.config.baseURL + '/ApiAsset_getAssetList.html?' + params(data)
}

// 供应商管理刊例
export function getVendorCardList (data) {
  return fly.post('ApiVendorCard_getVendorCardList.html', data)
}

export function exportVendorCardListToExcel (data) {
  return fly.config.baseURL + '//ApiVendorCard_getVendorCardList.html?' + params(data)
}

// 获取刊例详情
export function getVendorCardInfo (data) {
  return fly.post('ApiVendorCard_getVendorCardInfo.html', data)
}

//更新刊例
export function updateVendorCard (data) {
  return fly.post('ApiVendorCard_addOrUpdateVendorCard.html', data)
}

//刊例对比
export function getContrastInfo (data) {
  return fly.post('ApiVendorCard_getContrastInfo.html', data)
}